import { instance } from 'api/internaltools';

export const getWhitelistResourcesByStatus = async ({ status, page, searchParams }) => {
  return instance.get(`/whitelist-resources/status?status=${status}&page=${page}&search_params=${searchParams}`);
};

export const updateWhitelistResourceStatus = async (resourceId, payload) => {
  return instance.patch(`/whitelist-resources/${resourceId}`, payload);
};
